import { usePropsDisabled, useDataSource, usePropsRetargetingInfo, usePropsIOS14Visible } from './hooks';
import TtamPromotionApp from './app/promotion-app.vue';
import TtamPromotionAppTips from './tips/promition-app-tips.vue';
import TtamPromotionAppIosTips from './ios-tips/promition-app-ios-tips.vue';

export default {
  TtamPromotionApp,
  TtamPromotionAppTips,
  TtamPromotionAppIosTips,
  usePropsRetargetingInfo,
  usePropsIOS14Visible,
  usePropsDisabled,
  useDataSource,
};
